// extracted by mini-css-extract-plugin
export default {"root":"CellLabel_root__5Xgf7","label":"CellLabel_label__CnqJT","placeHolderShimmer":"CellLabel_placeHolderShimmer__hlb9g"};